import { styled } from '@/stitches.config';
import { Box } from '@base-app';
import { ReactComponent as SquareIcon } from '@assets/icons/square-icon.svg';

export const StyledReferencesContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'row'
});

export const StyledReferencesColumn = styled(Box, {
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'column',
  width: '50%',
});

export const StyledReferencesCell = styled(Box, {
  display: 'flex',
  flexDirection: 'row',
  marginTop: '$4'
});

export const StyledCellInfoContainer = styled(Box, {
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'column'
});

export const StyledSquare = styled(SquareIcon, {
  marginRight: '$3'
});

export const StyledLabel = styled('label', {
  color: '$darkBlue100',
  fontSize: '$md',
  fontWeight: '$bold',
  mb: '$1',
  textAlign: 'left',
});

export const StyledText = styled('p', {
  color: '$darkGray300',
  fontSize: '$md',
  margin: '0'
});
